import Styles from "./styles.module.scss";
import { ImageUrl } from "../../utils/CONSTANTS";
import LazyLoad from 'react-lazyload';

function AuthMedia() {

    return (
        <div className={Styles.loginImage}>
            <span className={Styles.graphicIconBig}></span>
            <div>
            <LazyLoad className={Styles.fullVideo}>
            <video autoPlay muted loop playsInline preload="none" className="lazy"  poster={`${ImageUrl}ellowbanner.jpg`}  >
                <source src={`${ImageUrl}ellowbanner.webm`} type="video/webm"/>
                <source src={`${ImageUrl}ellowbanner.mp4`} type="video/mp4"/>
                Your browser does not support the video tag.
            </video> 
            </LazyLoad>
            </div>
            <span className={Styles.graphicIconSmall}></span>
        </div>
        );
    }
    
export default AuthMedia;